module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19O3JF4/images/Cover.jpg?1718044916857",
      "alt": "This image is the cover for the book Blow Away #1, Blow Away"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blow Away #1, Blow Away\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Unyielding wildlife photographer Brynne Brautigan, isolated in the remote cold of Baffin Island, sees something she can’t unsee. An argument, followed by an outburst of intense violence between two nearby climbers—did she just witness a murder? In a frantic search for the truth, Brynne discovers just what she’s looking for, but little does she know that more than the silent white of winter is keeping her company… Hit writer Zac Thompson (Hunt for the Skinwalker, Cemetery Kids Don't Die) and star artist Nicola Izzo (Buffy: The Last Vampire Slayer) team up for this neo-noir crime thriller rife with murder and paranoia, in the tradition of Fargo and Rear Window!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Zac Thompson, Nicola Izzo\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    BOOM! Studios\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0